// OP-3619 — Casar o que a câmera leu com as peças da tela.
//
// Igualdade, não trecho: a leitura é o código inteiro da etiqueta, e um
// trecho marcaria a peça errada. Caixa e espaços nas pontas não contam.

export interface RetornoLeitura {
  texto: string
  tom: 'ok' | 'aviso' | 'erro'
}

const ehControle = (ch: string): boolean => {
  const c = ch.charCodeAt(0)
  return c < 32 || c === 127
}

/** Sem espaços nas pontas e sem caracteres de controle (separador GS1, CR/LF do leitor). */
export const normalizarCodigo = (codigo: string | null | undefined): string =>
  Array.from(String(codigo ?? '')).filter((ch) => !ehControle(ch)).join('').trim()

export function mesmoCodigo(a: string | null | undefined, b: string | null | undefined): boolean {
  const x = normalizarCodigo(a).toUpperCase()
  const y = normalizarCodigo(b).toUpperCase()
  return x !== '' && x === y
}

export function acharPorCodigo<T>(itens: T[], codigo: string, campos: (item: T) => Array<string | null | undefined>): T | null {
  return itens.find((item) => campos(item).some((c) => mesmoCodigo(c, codigo))) ?? null
}

export function eTelaDeToque(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches
}
